"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StripeCheckoutForm;
var _react = _interopRequireDefault(require("react"));
var _reactStripeJs = require("@stripe/react-stripe-js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // N.B. we are only importing a type, so no actual runtime code
// is included
function StripeCheckoutForm({
  children,
  disabled,
  onCheckout,
  onCheckoutStart,
  onCheckoutSuccess,
  onCheckoutError,
  ...otherProps
}) {
  const stripe = (0, _reactStripeJs.useStripe)();
  const elements = (0, _reactStripeJs.useElements)();
  const [checkoutInProgress, setCheckoutInProgress] = _react.default.useState(false);
  const [error, setError] = _react.default.useState(null);
  const onError = err => {
    setCheckoutInProgress(false);
    setError(err);
    if (onCheckoutError) onCheckoutError(err);
  };
  return /*#__PURE__*/_react.default.createElement("form", _extends({
    "data-test-id": "checkout-form"
  }, otherProps, {
    onSubmitCapture: async e => {
      e.preventDefault();
      if (checkoutInProgress || disabled) return;
      if (!stripe || !elements) {
        onError('Missing card info');
        return;
      }
      setCheckoutInProgress(true);
      if (onCheckoutStart) onCheckoutStart();
      const cardElement = elements.getElement('cardNumber');
      if (!cardElement) {
        onError('Missing card element');
        return;
      }
      try {
        const paymentMethodResponse = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement
        });
        if (!paymentMethodResponse || paymentMethodResponse.error) {
          onError(paymentMethodResponse.error && paymentMethodResponse.error.message || 'Unknown error');
          return;
        }
        const paymentMethod = paymentMethodResponse.paymentMethod;
        let result = await onCheckout({
          paymentMethodID: paymentMethod.id,
          setupIntentID: null
        });
        while (result.status === 'requires_action') {
          if (result.setupIntentID) {
            await stripe.handleNextAction({
              clientSecret: result.client_secret
            });
          } else {
            await stripe.handleCardAction(result.client_secret);
          }
          result = await onCheckout({
            paymentMethodID: paymentMethod.id,
            setupIntentID: result.setupIntentID
          });
        }
        if (result.status === 'success') {
          setCheckoutInProgress(false);
          if (onCheckoutSuccess) onCheckoutSuccess();
        } else {
          onError(result.message);
        }
      } catch (ex) {
        onError(ex.message);
        throw ex;
      }
    }
  }), children({
    error,
    checkoutInProgress
  }));
}